<section class="content-section crm-page">

  <!-- Header CRM -->
  <div class="crm-header">
    <button class="crm-back" [routerLink]="['/utilisateur/lister']" [queryParams]="{ scope: 'clients' }">
      <i class="fal fa-arrow-left"></i> Clients
    </button>

    <div class="crm-identity" *ngIf="client">
      <div class="crm-avatar crm-avatar--{{ segmentClient.couleur }}">
        {{ initiales(client.nom, client.prenom) }}
      </div>
      <div class="crm-identity-info">
        <div class="crm-nom">{{ client.nom }} {{ client.prenom }}</div>
        <div class="crm-meta-row">
          <span *ngIf="client.telephone" class="crm-meta"><i class="fal fa-phone"></i> {{ client.telephone }}</span>
          <span *ngIf="client.email" class="crm-meta"><i class="fal fa-envelope"></i> {{ client.email }}</span>
          <span *ngIf="client.ville" class="crm-meta"><i class="fal fa-map-marker-alt"></i> {{ client.ville }}</span>
        </div>
      </div>
      <div class="crm-badges">
        <span class="crm-segment crm-segment--{{ segmentClient.couleur }}">
          <i class="fal fa-{{ segmentClient.couleur === 'gold' ? 'crown' : 'user' }}"></i>
          {{ segmentClient.label }}
        </span>
        <span class="crm-type-badge">{{ client.typeUtilisateurLibelle || client.typeUtilisateur }}</span>
      </div>
    </div>

    <div class="crm-header-actions">
      <button class="crm-btn crm-btn--outline" (click)="nouvelleCommandeInterurbaine()">
        <i class="fal fa-route"></i> Interurbain
      </button>
      <button class="crm-btn crm-btn--primary" (click)="nouvelleCommandeUrbaine()">
        <i class="fal fa-plus"></i> Commande urbaine
      </button>
    </div>
  </div>

  <!-- KPIs enrichis -->
  <div class="crm-kpis" *ngIf="!chargement">
    <div class="crm-kpi">
      <div class="crm-kpi-icon crm-kpi-icon--indigo"><i class="fal fa-boxes"></i></div>
      <div>
        <div class="crm-kpi-val">{{ commandes.length }}</div>
        <div class="crm-kpi-label">Total commandes</div>
      </div>
    </div>
    <div class="crm-kpi">
      <div class="crm-kpi-icon crm-kpi-icon--green"><i class="fal fa-sack-dollar"></i></div>
      <div>
        <div class="crm-kpi-val">{{ montantGenere | number:'1.0-0' }}<span class="crm-kpi-unit">FCFA</span></div>
        <div class="crm-kpi-label">Chiffre d'affaires</div>
      </div>
    </div>
    <div class="crm-kpi">
      <div class="crm-kpi-icon crm-kpi-icon--blue"><i class="fal fa-check-circle"></i></div>
      <div>
        <div class="crm-kpi-val">{{ tauxAcceptation | number:'1.0-0' }}<span class="crm-kpi-unit">%</span></div>
        <div class="crm-kpi-label">Taux complétion</div>
      </div>
    </div>
    <div class="crm-kpi">
      <div class="crm-kpi-icon crm-kpi-icon--amber"><i class="fal fa-clock"></i></div>
      <div>
        <div class="crm-kpi-val">{{ delaiMoyenHeures | number:'1.0-0' }}<span class="crm-kpi-unit">h</span></div>
        <div class="crm-kpi-label">Délai moyen livraison</div>
      </div>
    </div>
    <div class="crm-kpi">
      <div class="crm-kpi-icon crm-kpi-icon--purple"><i class="fal fa-star"></i></div>
      <div>
        <div class="crm-kpi-val">{{ scoreFidelite }}<span class="crm-kpi-unit">/100</span></div>
        <div class="crm-kpi-label">Score fidélité</div>
        <div class="crm-score-bar">
          <div class="crm-score-fill" [style.width.%]="scoreFidelite"></div>
        </div>
      </div>
    </div>
    <div class="crm-kpi">
      <div class="crm-kpi-icon crm-kpi-icon--teal"><i class="fal fa-calendar-day"></i></div>
      <div>
        <div class="crm-kpi-val">{{ joursDepuisLastCmd }}<span class="crm-kpi-unit">j</span></div>
        <div class="crm-kpi-label">Depuis dernière cmd</div>
      </div>
    </div>
  </div>

  <!-- Onglets -->
  <div class="crm-tabs">
    <button class="crm-tab" [class.crm-tab--active]="ongletActif === 'historique'" (click)="ongletActif = 'historique'">
      <i class="fal fa-list-alt"></i> Historique commandes
    </button>
    <button class="crm-tab" [class.crm-tab--active]="ongletActif === 'stats'" (click)="ongletActif = 'stats'">
      <i class="fal fa-chart-bar"></i> Statistiques & activité
    </button>
  </div>

  <!-- Spinner -->
  <div *ngIf="chargement" class="crm-loading">
    <div class="crm-spinner"></div>
    <span>Chargement du profil client...</span>
  </div>

  <!-- Onglet Historique -->
  <ng-container *ngIf="!chargement && ongletActif === 'historique'">
    <div class="crm-filters">
      <select class="crm-select" [(ngModel)]="statutFiltre" (ngModelChange)="appliquerFiltres()">
        <option value="">Tous statuts</option>
        <option value="EN_ATTENTE">En attente</option>
        <option value="EN_LIVRAISON">En livraison</option>
        <option value="LIVRE">Livré</option>
        <option value="ANNULE">Annulé</option>
      </select>
      <input class="crm-input-date" type="date" [(ngModel)]="dateDebut" (change)="appliquerFiltres()" placeholder="De">
      <input class="crm-input-date" type="date" [(ngModel)]="dateFin" (change)="appliquerFiltres()" placeholder="À">
      <span class="crm-filter-count">{{ commandesFiltrees.length }} résultat(s)</span>
    </div>

    <div class="crm-types-row">
      <div class="crm-type-group">
        <span class="crm-type-group-label">
          <i class="fal fa-city"></i> Urbain
        </span>
        <span class="crm-type-chip crm-type-chip--express">
          <i class="fal fa-bolt"></i> <strong>{{ repartitionType('EXPRESS_URBAIN') }}</strong> Express
        </span>
        <span class="crm-type-chip crm-type-chip--standard">
          <i class="fal fa-cube"></i> <strong>{{ repartitionType('STANDARD_URBAIN') }}</strong> Standard
        </span>
      </div>
      <div class="crm-type-group">
        <span class="crm-type-group-label">
          <i class="fal fa-route"></i> Interurbain
        </span>
        <span class="crm-type-chip crm-type-chip--express">
          <i class="fal fa-bolt"></i> <strong>{{ repartitionType('EXPRESS_INTERURBAIN') }}</strong> Express
        </span>
        <span class="crm-type-chip crm-type-chip--standard">
          <i class="fal fa-cube"></i> <strong>{{ repartitionType('STANDARD_INTERURBAIN') }}</strong> Standard
        </span>
      </div>
    </div>

    <div class="crm-table-wrap">
      <table class="crm-table">
        <thead>
          <tr><th>Référence</th><th>Date</th><th>Type</th><th>Statut</th><th>Montant</th></tr>
        </thead>
        <tbody>
          <tr *ngFor="let c of commandesFiltrees" class="crm-row" [routerLink]="['/commande/enregistrer', c.id]" [queryParams]="{ mode: 'view' }" style="cursor:pointer">
            <td class="crm-td-ref">{{ c.numeroCommande || c.id }}</td>
            <td>{{ c.dateCreation | date:'dd/MM/yyyy HH:mm' }}</td>
            <td><span [class]="classPill(c.typeEnvoi)">{{ labelType(c.typeEnvoi) }}</span></td>
            <td>
              <span class="crm-statut-badge"
                    [class.crm-statut-badge--green]="c.statut === 'LIVRE'"
                    [class.crm-statut-badge--red]="c.statut === 'ANNULE' || c.statut === 'ANNULEE'"
                    [class.crm-statut-badge--blue]="c.statut === 'EN_LIVRAISON'"
                    [class.crm-statut-badge--amber]="c.statut === 'EN_ATTENTE'">
                {{ c.statut }}
              </span>
            </td>
            <td class="crm-td-amount">{{ c.montantAPayer | number:'1.0-0' }} FCFA</td>
          </tr>
          <tr *ngIf="!commandesFiltrees.length">
            <td colspan="5" class="crm-empty">Aucune commande pour ces filtres</td>
          </tr>
        </tbody>
      </table>
    </div>
  </ng-container>

  <!-- Onglet Stats -->
  <ng-container *ngIf="!chargement && ongletActif === 'stats'">
    <div class="crm-stats-grid">

      <!-- Chart activité -->
      <div class="crm-chart-card crm-chart-card--large">
        <div class="crm-chart-title"><i class="fal fa-chart-bar"></i> Activité sur 6 mois</div>
        <div echarts [options]="chartActivite" class="crm-chart"></div>
      </div>

      <!-- Répartition type -->
      <div class="crm-chart-card">
        <div class="crm-chart-title"><i class="fal fa-layer-group"></i> Types de commandes</div>
        <div class="crm-repartition">
          <div class="crm-rep-group">
            <div class="crm-rep-group-title"><i class="fal fa-city"></i> Urbain</div>
            <div class="crm-rep-item">
              <span class="crm-rep-dot crm-rep-dot--express-u"></span>
              <span class="crm-rep-label">Express</span>
              <span class="crm-rep-val">{{ repartitionType('EXPRESS_URBAIN') }}</span>
            </div>
            <div class="crm-rep-item">
              <span class="crm-rep-dot crm-rep-dot--standard-u"></span>
              <span class="crm-rep-label">Standard</span>
              <span class="crm-rep-val">{{ repartitionType('STANDARD_URBAIN') }}</span>
            </div>
          </div>
          <div class="crm-rep-divider"></div>
          <div class="crm-rep-group">
            <div class="crm-rep-group-title"><i class="fal fa-route"></i> Interurbain</div>
            <div class="crm-rep-item">
              <span class="crm-rep-dot crm-rep-dot--express-i"></span>
              <span class="crm-rep-label">Express</span>
              <span class="crm-rep-val">{{ repartitionType('EXPRESS_INTERURBAIN') }}</span>
            </div>
            <div class="crm-rep-item">
              <span class="crm-rep-dot crm-rep-dot--standard-i"></span>
              <span class="crm-rep-label">Standard</span>
              <span class="crm-rep-val">{{ repartitionType('STANDARD_INTERURBAIN') }}</span>
            </div>
          </div>
        </div>
      </div>

      <!-- Dernière commande -->
      <div class="crm-info-card" *ngIf="derniereCommande">
        <div class="crm-chart-title"><i class="fal fa-history"></i> Dernière commande</div>
        <div class="crm-last-cmd">
          <div class="crm-last-ref">{{ derniereCommande.numeroCommande || '#' + derniereCommande.id }}</div>
          <div class="crm-last-date">{{ derniereCommande.dateCreation | date:'dd MMMM yyyy' }}</div>
          <div class="crm-last-type"><span [class]="classPill(derniereCommande.typeEnvoi)">{{ labelType(derniereCommande.typeEnvoi) }}</span></div>
          <div class="crm-last-amount">{{ derniereCommande.montantAPayer | number:'1.0-0' }} FCFA</div>
        </div>
      </div>

      <!-- Profil fidélité -->
      <div class="crm-info-card">
        <div class="crm-chart-title"><i class="fal fa-star"></i> Profil fidélité</div>
        <div class="crm-fidelite">
          <div class="crm-segment-big crm-segment-big--{{ segmentClient.couleur }}">
            {{ segmentClient.label }}
          </div>
          <div class="crm-score-detail">
            <span>Score</span>
            <div class="crm-score-bar crm-score-bar--lg">
              <div class="crm-score-fill" [style.width.%]="scoreFidelite"></div>
            </div>
            <span class="crm-score-num">{{ scoreFidelite }}/100</span>
          </div>
          <div class="crm-fid-meta">
            <span><i class="fal fa-calendar"></i> {{ joursDepuisLastCmd }}j depuis dernière commande</span>
            <span><i class="fal fa-boxes"></i> {{ commandes.length }} commandes au total</span>
          </div>
        </div>
      </div>

    </div>
  </ng-container>

</section>
